import { add } from 'date-fns'
import { getCookie, setCookie, deleteCookie } from '@/shared/utils/Cookies'

type StorageType = 'local' | 'session'
const DEFAULT_STORAGE_PREFIX = 'travel-qatar-cache_'

export class CacheService {
  private keyPrefix: string
  private storage: Storage

  constructor(storageType: StorageType = 'local', prefix: string = DEFAULT_STORAGE_PREFIX) {
    this.storage = storageType === 'session' ? sessionStorage : localStorage
    this.keyPrefix = prefix
  }

  set(name: string, value: object | string, expires: any = Infinity) {
    const expiresDate = expires === Infinity ? new Date(2100, 12, 12) : add(new Date(), expires)
    const key = this.keyPrefix + name
    setCookie(key, name, { expires: expiresDate })
    this.storage.setItem(key, JSON.stringify(value))
  }

  update(name: string, propertyKey: any, propertyValue: any) {
    const currentData = this.get(name) || {}
    currentData[propertyKey] = propertyValue
    this.set(name, currentData)
  }

  get(name: string) {
    const key = this.keyPrefix + name
    const isExpired = !getCookie(key)
    if (isExpired) {
      this.storage.removeItem(key)
      return null
    }

    return this.getFromStorage(name)
  }

  getFromStorage(name: string) {
    const key = this.keyPrefix + name
    const item = this.storage.getItem(key)
    return item ? JSON.parse(item) : null
  }

  delete(name: string) {
    const key = this.keyPrefix + name
    deleteCookie(key)
    this.storage.removeItem(key)
  }
}

export const useCacheService = (storageType: StorageType = 'local', keyPrefix?: string) =>
  new CacheService(storageType, keyPrefix)
